import * as Scrivito from "scrivito";

export const QuoteSliderPanel = Scrivito.connect(({ quote }) => {
  if (!quote) return null;

  return (
    <div className="quote-widget-quote">
      <Scrivito.ImageTag
        content={quote}
        attribute="image"
        className="quote-widget-quote__image"
        alt={unescape(quote.get("author"))}
        loading="lazy"
      />
      <div className="quote-widget-quote__content">
        <Scrivito.ContentTag
          tag="blockquote"
          className="quote-widget-quote__quote"
          content={quote}
          attribute="content"
        />
        <Scrivito.ContentTag
          className="quote-widget-quote__author"
          content={quote}
          attribute="author"
          tag="div"
        />
        <Scrivito.ContentTag
          className="quote-widget-quote__function"
          content={quote}
          attribute="function"
          tag="div"
        />
      </div>
    </div>
  );
});
